// extracted by mini-css-extract-plugin
export default {"social_medias":"SocialMedias_social_medias__GNq6K"};